export { default } from "./DeleteModalWithConfirm";
